/** The shape both `bulk-create` endpoints (matter and chat) echo back per created document. */
export interface BulkCreatedDocument {
  fletchDocumentId: string;
  documentName: string;
}

export interface PairedDocument {
  file: File;
  documentId: string;
}

/** Matches `bulk-create` results to their `File`s: by index when counts match, otherwise by name. */
export function pairCreatedDocuments(files: File[], documents: BulkCreatedDocument[]): PairedDocument[] {
  if (documents.length === files.length) {
    return documents.map((document, index) => ({ file: files[index], documentId: document.fletchDocumentId }));
  }

  const filesByName = new Map<string, File[]>();
  for (const file of files) {
    const queue = filesByName.get(file.name);
    if (queue) {
      queue.push(file);
    } else {
      filesByName.set(file.name, [file]);
    }
  }

  const paired: PairedDocument[] = [];
  for (const document of documents) {
    const file = filesByName.get(document.documentName)?.shift();
    if (file) {
      paired.push({ file, documentId: document.fletchDocumentId });
    }
  }
  return paired;
}
